import { RouteProps } from "react-router-dom";
import styles from "./assets/styles.module.scss";
import Menu from "./Components/Menu";
import leftHand from "./assets/leftHand.png";
import rightHand from "./assets/rightHand.png";
import stoneTable from "./assets/stoneTable.png";
import RuneAltar from "./Components/RuneAltar";
import useGame from "./RunicMemoriseContext";
import GameModal from "./Components/GameModal";

const RunicMemorise: React.FC<RouteProps> = () => {
  const {
    start,
    setStart,
    runesArray,
    secuenceArray,
    iluminate,
    currentIndexSelect,
    checkInputArray,
    simonState
  } = useGame();

  return (
    <div className={styles.gameContainer}>
      <div className={styles.gameBox}>
        {!start ? (
          <Menu onStart={() => setStart(true)} />
        ) : (
          <div className={styles.game}>
            <div className={styles.runeShowContainer}>
              <img src={rightHand} alt='right hand image' />
              <div className={styles.showRunes}>
                {checkInputArray.map(item => (
                  <img src={item} alt='rune' />
                ))}
              </div>
              <img src={leftHand} alt='left hand image' />
            </div>
            <div className={styles.runesTable}>
              <div className={styles.altars}>
                {runesArray.map((img, index) =>
                  img === secuenceArray[currentIndexSelect] ? (
                    <RuneAltar ilumination={iluminate} id={index} rune={img} />
                  ) : (
                    <RuneAltar ilumination={!iluminate} id={index} rune={img} />
                  )
                )}
              </div>
              <div className={styles.stoneTableContainer}>
                <img
                  className={styles.stoneTable}
                  src={stoneTable}
                  alt='stone table to runes altars'
                />
                <div className={styles.message}>
                  {simonState === "simonDice" ? (
                    <p>Look the secuence and memorise them</p>
                  ) : (
                    <p>
                      Is your turn, select the runes in the same order that
                      iluminated it
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <GameModal />
    </div>
  );
};

export default RunicMemorise;
